import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  getRequestId,
  isEnqueueAvailable,
} from 'src/routes/SearchPage/selectors/searchParams';
import { getIsMobile } from 'src/store/view/selectors';
import {
  addWishlistItem,
  getWishlistDataAction,
  removeWishlistItem,
} from 'src/store/wishlist/actions';
import {
  activeItemIdSelector,
  isActiveSelector,
} from 'src/store/wishlist/selectors';
import Wishlist from './Wishlist';

export type Props = {
  wishlistIdentifier: number;
  type: 'package' | 'hotel';
  price: number;
  isCheckoutPage?: boolean;
  isHotelPage?: boolean;
  isWhiteHeart?: boolean;
  isHotelCardFromMap?: boolean;
  isMobileHotelPage?: boolean;
  isSeoPage?: boolean;
};

const mapStateToProps = (state, props: Props) => ({
  isContainedInWishlist: isActiveSelector(state, props.wishlistIdentifier),
  wishlistItemId: activeItemIdSelector(state, props.wishlistIdentifier),
  isMobile: getIsMobile(state),
  /**
   * Селектор падает, если нет в сторе enqueue, поэтому проверяем, есть ли стор enqueue
   */
  requestId: (isEnqueueAvailable(state) && getRequestId(state)) || undefined,
});

const mapDispatchToProps = {
  addToWishlist: addWishlistItem,
  removeFromWishlist: removeWishlistItem,
  getWishlistData: getWishlistDataAction,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(Wishlist);
